import { CONFIG } from 'src/global-config';
import { DashboardLayout } from 'src/layouts/dashboard';
import { BiometricSessionGate } from 'src/sections/artham/shared/biometric-gate';

import { AuthGuard } from 'src/auth/guard';

// ----------------------------------------------------------------------

type Props = {
  children: React.ReactNode;
};

export default function Layout({ children }: Props) {
  if (CONFIG.auth.skip) {
    return (
      <BiometricSessionGate>
        <DashboardLayout>{children}</DashboardLayout>
      </BiometricSessionGate>
    );
  }

  return (
    <AuthGuard>
      <BiometricSessionGate>
        <DashboardLayout>{children}</DashboardLayout>
      </BiometricSessionGate>
    </AuthGuard>
  );
}
